import { render } from "./LeaveTypeEdit.vue?vue&type=template&id=67f8a394"
import script from "./LeaveTypeEdit.vue?vue&type=script&lang=js"
export * from "./LeaveTypeEdit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueProject\\leeten-hrm-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__